export const projects = [
  {
    title: "E-commerce",
    subtitle: "JS Mastery Ecommerce",
    description:
      "An e-commerce website",
    image: "./project-1.jpeg",
    link: "https://ecommerce-pheobeayo.vercel.app/",
  },
  {
    title: "Vetly",
    subtitle: "Vetting App",
    description:
      "A Talent Vetting App",
    image: "./project-2.jpeg",
    link: "https://dev-vetlyapp.netlify.app/",
  },
  {
    title: "simple Redux App",
    subtitle: "React and Redux",
    description:
      "A simple redux app for data",
    image: "./project-3.jpeg",
    link: "https://simple-redux-app.netlify.app/",
  },
  {
    title: "My NFT collections",
    subtitle: "NFT",
    description:
      "An NFT collections website",
    image: "./project-4.jpeg",
    link: "https://my-nft-collection.pheobeayo.repl.co",
  },
  {
    title: "Krypto staking",
    subtitle: "KRYPTO",
    description:
      "A Defi Staking Application",
    image: "./project-5.jpg",
    link: "https://krypto-frontend-snowy.vercel.app/",
  },
  {
    title: "Qualify",
    subtitle: "A blockchain Vetting App",
    description:
      "An Application that vets talents",
    image: "./project-6.jpg",
    link: "https://qualify-rosy.vercel.app/",
  },
  {
    title: "GoldCart",
    subtitle: "An Ecommerce Website",
    description:
      "An e-commerce application that sells digital products",
    image: "./project-7.jpg",
    link: "https://goldcart.netlify.app/",
  },
];



export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "GraphQL",
  "Material UI",
  "Chakra UI",
  "Redux",
  "React-Query",
  "HTML-5",
  "CSS",
  "Python"
];



// WEBPACK FOOTER //
// ./src/data.js